import { useState, useMemo } from "react";
import { State, VectorTile as VectorTileSource } from "../../../reactOL/source";
import MVT from "ol/format/MVT.js";
import VectorTile from "../../../reactOL/layers/VectorTile";
import { useViewContext } from "../../../../context/View/ViewContext";
import { createCountryStyle } from "./CountryVectorTileStyling";
import { useThemeContext } from "../../../theme/ThemeContext";
import { Theme } from "../../../../constant/Theme";

interface CountryVectorTileLayerProps {
  visible: boolean;
  inclusions: string[];
}

const CountryVectorTileLayer = ({
  visible,
  inclusions,
}: CountryVectorTileLayerProps) => {
  const { projection, tileGrid, setLoading } = useViewContext();
  const { theme } = useThemeContext();

  const [countryTileSource] = useState(
    VectorTileSource({
      url: `https://d2q3ceuxo0dm8y.cloudfront.net/CountryTiles/{z}/{x}/{y}.mvt`,
      onStateChange: (state: State) => setLoading(state === State.Loading),
      authorizationToken: null,
      projection: projection,
      format: new MVT(),
      tileGrid: tileGrid,
    }),
  );

  const style = useMemo(
    () => createCountryStyle(inclusions, theme === Theme.DARK),
    [inclusions, theme],
  );

  return (
    <VectorTile
      source={countryTileSource}
      style={style}
      zIndex={9000}
      visible={visible}
    />
  );
};

export default CountryVectorTileLayer;
